import React from 'react'
import { Box, Divider, Grid, Typography } from '@mui/material'
import FlagIcon from '@mui/icons-material/FlagOutlined';
import VisibilityIcon from '@mui/icons-material/VisibilityOutlined';
import imgUs from '../assets/images/ui/nosotros.svg'
import logo from '../assets/images/logo/logo_dark.svg'
import Paper from '@mui/material/Paper';

function AboutUs() {
  return (
  <>
  <Box component="section" sx={{my: 4}}>
    <Box component="blockquote" sx={{ py: 8, px: 2 }}>
      <Typography variant='h2' textAlign='center' gutterBottom>
      "El <mark>éxito</mark> es la suma de todos los <mark>esfuerzos</mark>"
      </Typography>
      <Typography variant='h5' textAlign='right'>
      -Robert Collier
      </Typography>
    </Box>
  </Box>


  <Grid container
    component="section"
    id="home"
    justifyContent="center"
    alignItems="center"
    sx={{ py: 16 }}
    spacing={{ xs: 2, md: 3, lg: 8 }}
    className='gl'
  >
    <Grid item xs={12} md={4}>
      <img src={logo} alt="Íconos de trabajadores"/>
    </Grid>
    <Grid item xs={12} md={6} display='flex' flexDirection='column' gap='1em'>
      <Typography variant='h2' textAlign='center'> ¿Quiénes somos? </Typography>
      <Typography>
      ECSUP es una empresa que dispone de profesionales con más de 20 años de experiencia en el rubro de la electricidad doméstica, industrial e institucional a partir de la realización mediciones electromecánicas, siguiendo las regulaciones de la industria.
      </Typography>
      <Typography>
      Estamos avocados a la atención integral de las variadas empresas para contribuir con el desarrollo y potencialidades tecnológicas de las mismas y así promover el éxito mutuo.
      </Typography>
    </Grid>
  </Grid>
  
  <Grid container
  component="section"
  justifyContent="space-around"
  textAlign='center'
  sx={{ py: 8 }}
  >
    <Grid item xs={12} md={4} sx={{ py: 8 }}>
      <Typography variant='h2'> Misión </Typography>
      <FlagIcon sx={{ fontSize: 96 }} color="secondary"/>
      {/* <i className="fas fa-handshake"></i> */}
      <Typography>
      Brindar soluciones de ágil implementación y mantenimiento, en el mejor estatus de productividad, a las maquinarias de nuestros clientes.
      </Typography>
    </Grid>
    <Grid item xs={12} md={4} sx={{ py: 8 }}>
      <Typography variant='h2'> Visión </Typography>
      <VisibilityIcon sx={{ fontSize: 96 }} color="secondary"/>
      {/* <i className="far fa-eye"></i> */}
      <Typography>
      Convertirnos en una empresa de gran demanda nacional e internacional en brindar soluciones y soportes a dispositivos tecnológicos.
      </Typography>
    </Grid>
  </Grid>

  </>
  )
}

export default AboutUs